<template>
    <div>
        <div class="alertContain">
            <b-modal id="alertModal" v-bind:title="title" v-model="modalShow" @show="modalShowFunc" @hidden="modalHideFunc"
                hide-footer v-bind:no-close-on-backdrop="isBackDrop">
                <div class="bodyContents">
                    <p class="txtCenter" id="modalTxt">
                        {{ contents }}
                    </p>
                </div>
                <div class="modalConfirmBtnBox">
                    <b-button class="modalConfirmBtn" block @click="$bvModal.hide('alertModal')">확인</b-button>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { eventBus } from '@/main.js';

export default {
    name: 'AlertModal',
    data() {
        return {
            modalShow: false
        }
    },
    computed: {
        ...mapState("modal", ["title", "contents", "focusItem", "isBackDrop"])
    },
    methods: {
        modalShowFunc() {

        },
        modalHideFunc() {
            if (this.$store.state.modal.focusItem) {
                eventBus.$emit("callForFocus");
            }
        }
    }

}
</script>